/*::* FOOTER LINK *::*/
document.addEventListener("DOMContentLoaded", () => {
  const footerCopy = document.querySelector(".wt-footer__aside__copy");
  if (footerCopy) {
    footerCopy.innerHTML = footerCopy.innerHTML.replace(
      /(Web by ::\*)/,
      '<a href="https://plaimanas.com/" target="_blank" rel="noopener noreferrer">$1</a>'
    );
  }
});